import type { VoidFunctionComponent } from 'react';
import Button from '../../../generic/Button';
import { IgnoreIssuesModalDetailsContainer } from '../../modals';
import { ignoreOrResolveWord } from '../../../../utils';
import { SELECTED_ISSUE_COUNT } from './shared';
import { useIssueDetailsModals } from '../IssueDetailsModalsContext';
import type { ActionButtonAndModalProps } from './shared';

/**
 * IssueDetailsActionButtonIgnore includes the button and the modal
 * for the ignore action on the issue details page and drawer. The modal state is managed
 * by useIssueDetailsModals, which passes the modal state down as context. Go see the
 * IssueDetailsModalsContext for more info.
 */
const IssueDetailsActionButtonIgnore: VoidFunctionComponent<ActionButtonAndModalProps> = ({ id }) => {
  const { ignoreModal, isAnyModalOpen } = useIssueDetailsModals();
  return (
    <>
      <Button
        type="secondary"
        size="medium"
        onClick={ignoreModal.onOpen}
        isDisabled={isAnyModalOpen}
      >
        {ignoreOrResolveWord()}
      </Button>
      <IgnoreIssuesModalDetailsContainer
        id={id}
        show={ignoreModal.isOpen}
        onHide={ignoreModal.onClose}
        selectedIssuesCount={SELECTED_ISSUE_COUNT}
      />
    </>
  );
};

export default IssueDetailsActionButtonIgnore;
